import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { CbreSnackBarConfiguration } from '../alerts.model';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'cbre-custom-snack',
  templateUrl: 'custom-snack.component.html',
  styleUrl: 'custom-snack.component.scss',
})
export class CustomSnackComponent {
  public message = '';
  public closeText = '';
  private readonly params: CbreSnackBarConfiguration;
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) data,
    private ref: MatSnackBarRef<CustomSnackComponent>
  ) {
    this.message = data.message;
    this.closeText = data.actionButton;
    this.params = data;
  }

  public close() {
    this.ref.dismiss();
  }
}
